var map = {
	"./tapcoin/new/blind/bind-box.png": 16670,
	"./tapcoin/new/blind/bind-select.png": 31329,
	"./tapcoin/new/blind/blind-container-bg.png": 65899,
	"./tapcoin/new/blind/blind-items-board.png": 29146,
	"./tapcoin/new/blind/reward-box.png": 39264,
	"./tapcoin/new/blind/reward-select.png": 6608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50222;